import { useContext, useEffect, useState } from "react";
import TicketList from "../../components/TicketList";
import { DataProvider } from "../../store/ContextProvider";

export const Tickets = () => {
    const { handleTickets, getTickets, currentUser } = useContext(DataProvider);
    const [perPage, setPerPage] = useState(5)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [totalCount, setTotalCount] = useState(1)

    useEffect(() => {
        handleTickets(perPage, currentPage, setTotalPages, setTotalCount);
    }, [perPage, currentPage]);

    return (
        <div className="py-6 min-h-[65vh] bg-[#F8F8F8]">
            {/* Heading */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-lg font-semibold">Manage Tickets</h2>
                    <p className="text-sm text-gray-500">
                        Track ticket progress and resolve issues efficiently.
                    </p>
                </div>
                {['job-seeker', 'employer'].includes(currentUser?.role) && (
                    <button
                        type="button"
                        onClick={() => window.location.href = '/raise-ticket'}
                        className="bg-primary-500 text-white px-3 py-1 rounded-md font-semibold text-sm hover:bg-primary-600 transition-colors"
                    >
                        + Create Ticket
                    </button>
                )}
            </div>

            <TicketList getTickets={getTickets} perPage={perPage} setPerPage={setPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} totalCount={totalCount} />

        </div>
    );
};